export default __webpack_public_path__ + "static/media/rangel.6197ed97.svg";